import { FC } from "react";
import { TAlertDialogProps } from "./AlertDialog.config";
import { Dialog } from "../Dialog";

export const AlertDialog: FC<TAlertDialogProps> = ({ ...props }) => (
  <Dialog {...props}></Dialog>
);
